import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'wrap' })

export class WrapPipe implements PipeTransform {
    transform(value: string, wrapper: {search: string, class: string}) {
        return value.replace(wrapper.search, '<span class="' + wrapper.class + '">' + wrapper.search + '</span>');
    }
}
